var _                    = require('lodash');
var ajaxAsObservable     = require('ub/control/ajax-as-observable');
var moment               = require('moment');
var VersionControlDialog = require('ub/lp/editor/dialogs/version-control-dialog');
var AlertDialog          = require('ub/ui/alert-dialog');
var userEventTracking    = require('ub/user-event-tracking').default;
var ubBanzai             = require('ub/control/banzai-features');
var jQuery               = require('jquery');
var pomMerger            = require('ub/ui/pom-merger');
var endpoints            = require('ub/config/endpoints').default;

var VersionControl = function(editor0) {
  this.editor = editor0;
};

VersionControl.prototype = {
  showDialog: function() {
    this.dialog = new VersionControlDialog({
      onRestore          : this._beforeRestoreCheck.bind(this),
      onOpen             : this._getListOfPageSaves.bind(this),
      state              : 'loading',
      lastRestorePosition: this.lastRestorePosition
    });

    this.dialog.safeOpen();

    return this.dialog;
  },

  _beforeRestoreCheck: function(pomPath) {
    var self = this;

    if (this.editor.hasUnsavedChanges()) {
      new AlertDialog({
        title: 'Unsaved Changes',
        confirmLabel: 'OK',
        showCancelButton: true,
        onConfirm: function() {
          self._getPomSaveFromS3(pomPath);
          self.dialog.close();
        },
        message: 'You have unsaved changes.',
        secondaryMessage: 'If you continue without saving, these changes will be permanently discarded.',
        icon: 'error'
      }).safeOpen();
    } else {
      this._getPomSaveFromS3(pomPath);
      this.dialog.close();
    }
  },

  _renderVersionControlDialogList: function(data) {
    var pomSaveList = _.map(data, function(pagePath) {
      var dateString = pagePath.replace(/-[0-9]*.json.gz/, '');
      var momentDate = moment.utc(dateString, 'YYYY-MM-DD/HH:mm:ss:SS').local();

        return {
          label: momentDate.format('ddd - MMM DD, YYYY - hh:mm:ss A'),
          value: pagePath
        };
    });

    this.dialog.options.state = 'loaded';
    this.dialog.options.menuItems = pomSaveList;
    this.dialog.render(this.dialog.options);
    this.dialog.scrollToActiveItem();
  },

  _renderLoadErrorDialog: function() {
    this.dialog.options.state = 'loadError';
    this.dialog.render(this.dialog.options);
  },

  _restorePageData: function(restorePomData, pomPath) {
    var currentPomData = this.editor.buildSaveDataJSON();
    var newPom = pomMerger.buildNewPomForRestore(currentPomData, restorePomData, this.editor);

    _.forEach(this.editor.pages, function(page) {
      this.editor.removePageListenersAndTabs(page);
    }.bind(this));

    this._resetPages();

    this.editor.loadPageData(newPom, window.lp.pom.context.EDIT, true);

    _.forEach(this.editor.pages, function(page) {
      page.undoManager.clearQueues();
    });

    this.lastRestorePosition = pomPath;
  },

  _removePageReferences: function() {
    this.editor.mainPage = null;
    this.editor.page = null;
    this.editor.pages = [];
  },

  _resetPages: function() {
    _.forEach(this.editor.pages, function(page) {
      page.removePage();
    });

    this._removePageReferences();
  },

  _getVariantId: function() {
    var mainPageIdExists = this.editor && this.editor.mainPage && this.editor.mainPage.id;
    return mainPageIdExists ? this.editor.mainPage.id : undefined;
  },

  _getListOfPageSaves: function() {
    var self = this;
    var requestObj = {
      type: 'GET',
      url: endpoints.savesList(this._getVariantId()),
    };

    ajaxAsObservable(requestObj)
    .subscribe(
      function(ev) {
        var savesList = Array.isArray(ev.data) ? ev.data : [];

        self._renderVersionControlDialogList(savesList);

        self._sendUserEventTrackingData({
          eventName: 'loadedVersionsList',
          numberOfSaves: savesList.length
        });
      },
      function() {
        self._renderLoadErrorDialog();
      }
    );
  },

  _sendUserEventTrackingData: function(eventData) {
    if (ubBanzai.features.isVersionControlEventTrackingEnabled()) {
      userEventTracking.trackEvent(eventData, 'version_control_events');
    }
  },

  _showLoadingOverlay: function(){
    var $loading = jQuery('#loading');

    $loading.addClass('version-control');
    $loading.find('p').html('Rolling back to a previous version');
    $loading.show();
  },

  _getPomSaveFromS3: function(pomPath) {
    this._showLoadingOverlay();

    this._sendUserEventTrackingData({
      eventName: 'selectedVersionToRestore',
      pomPath: pomPath
    });

    var self = this;
    var requestObj = {
      type: 'GET',
      url: endpoints.savedData(this._getVariantId(), pomPath),
    };

    ajaxAsObservable(requestObj)
    .subscribe(
      function(response) {
        self._restorePageData(response.data.data.savePayload, pomPath);
      },
      function() {
        new AlertDialog({
          title: 'Unable to rollback',
          confirmLabel: 'OK',
          onConfirm: function() {
            jQuery('#loading').hide();
          },
          message: 'We\'re unable to obtain the historical data you\'ve selected',
          secondaryMessage: 'Please try again later, or contact support if this problem persists',
          icon: 'error'
        }).safeOpen();
      }
    );
  }
};

module.exports = VersionControl;



// WEBPACK FOOTER //
// ./src/ui/version-control.js